import React from "react";
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import CoinButton from "./CoinButton";
import { doesTokenExist } from "../ethereumFunctions";
import PropTypes from "prop-types";
import * as COLORS from "@material-ui/core/colors";

const styles = (theme) => ({
  dialogContainer: {
    borderRadius: theme.spacing(2),
    backgroundColor: "rgba(37, 44, 69)", // Adjusted for transparency
    color: "white",
  },
  titleSection: {
    padding: theme.spacing(2),
  },
  titleText: {
    alignSelf: "center",
    color: COLORS.green[50], // Changed title text color to light green
  },
  hr: {
    margin: 0,
    backgroundColor: COLORS.green[50], // Changed horizontal line color to light green
    height: "2px", // Increased line thickness
  },
  address: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#004d40", // Dark green background
      color: "white", // White text color
      "& fieldset": {
        borderColor: "#00ff00", // Green border color
      },
      "&:hover fieldset": {
        borderColor: "#00ff00", // Green border on hover
      },
    },
    "& .MuiInputBase-input": {
      color: "white", // White text color in input
    },
    "& .MuiFormHelperText-root": {
      color: "red", // Error message in red
    },
  },
  coinList: {
    height: "315px",
    overflowY: "scroll",
    color: COLORS.green[50], // Light green text color for the coin list
    backgroundColor: COLORS.grey[800],
  },
  coinContainer: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(0.5),
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
    overflow: "hidden",
  },
});

// Custom useStyles hook
const useStyles = makeStyles(styles);

// Custom DialogTitle component
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.titleSection}
      {...other}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignContent="center"
      >
        <Typography variant="h6" className={classes.titleText}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon style={{ color: COLORS.green[50] }} /> {/* Close icon color */}
          </IconButton>
        ) : null}
      </Grid>
    </MuiDialogTitle>
  );
});

// Custom DialogActions component
const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "rgba(37, 44, 69)", // Dialog actions background with transparency
  },
}))(MuiDialogActions);

CoinDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  coins: PropTypes.array.isRequired,
};

export default function CoinDialog(props) {
  const classes = useStyles();
  const { onClose, open, coins, signer, ...others } = props;

  const [address, setAddress] = React.useState("");
  const [error, setError] = React.useState("");

  const submit = () => {
    if (doesTokenExist(address, signer)) {
      exit(address);
    } else {
      setError("This address is not valid");
    }
  };

  const exit = (value) => {
    setError("");
    setAddress("");
    onClose(value);
  };

  return (
    <Dialog
      open={open}
      onClose={() => exit(undefined)}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.dialogContainer }}
    >
      <DialogTitle onClose={() => exit(undefined)}>Select Token</DialogTitle>

      <hr className={classes.hr} />

      <div className={classes.coinContainer}>
  <Grid container direction="column" spacing={2} alignContent="center">
    <TextField
      value={address}
      onChange={(e) => setAddress(e.target.value)}
      variant="outlined"
      placeholder="Paste Token Address"
      error={error !== ""}
      helperText={error}
      fullWidth
      className={classes.address}
      InputProps={{
        style: {
          backgroundColor: "#004d40", 
          color: "white", 
        },
      }}
      InputLabelProps={{
        style: {
          color: "white", 
        },
      }}
    />

          <hr className={classes.hr} />

          <Grid item className={classes.coinList}>
            <Grid container direction="column">
              {coins.map((coin, index) => (
                <Grid item key={index} xs={28}>
                  <CoinButton
                    coinName={coin.name}
                    coinAbbr={coin.abbr}
                    imageURI={coin.imageURI}
                    onClick={() => exit(coin.address)}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </div>

      <hr className={classes.hr} />

      <DialogActions>
  <Button
    autoFocus
    onClick={submit}
    style={{ color: "white", backgroundColor: "transparent" }} 
  >
    <b>ENTER</b>
  </Button>
</DialogActions>

    </Dialog>
  );
}
